import { renameFieldHandler } from './RenameFieldStmt';
export * from './RenameFieldStmt';
export const schemaFieldHandlers = [renameFieldHandler];
//# sourceMappingURL=index.js.map